:host {
  display: inline-block;
  pointer-events: none;
}

.avatar-container {
  display: flex;
  align-items: center;
  gap: 4px;
  line-height: 0;
}

.avatar {
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  color: var(--pure-white);

  .image {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}

:host(.square) {
  .avatar {
    border-radius: 10px;
  }
}

.avatar.avatar-initials {
  background: var(--primary-main);
}

.avatar.avatar-image {
  background: var(--primary-main);
}

:host(.inverted) {
  .avatar {
    color: var(--primary-main);
  }

  .avatar.avatar-initials {
    background: var(--primary-main);
  }
}
